<template>
  <div id="ProductCategories">
    <div class="GridB6639132">
      <div class="GridF3434C50"  v-for="item in textData" :key="item.value" @click="getTime(item.prodClass)">
        <div class="Grid1C098D05">
          <span text="'月供存款'">{{item.prodName}}</span>
        </div>
        <div class="Grid9E420243">
          <span text="'宣传话术'" class="textUp">{{item.prodDesc}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BUYTIMESTATE, LOGINPRODLIST } from '../../api/smartdeposit'
import { Dialog } from '@gidc/mobile'
import { mapGetters } from 'vuex'
export default {
  name: 'ProductCategories',
  components: {
    [Dialog.name]: Dialog
  },
  computed: {
    ...mapGetters([
      'RnInfo'
    ])
  },
  data () {
    return {
      textData: [
      ],
      showRegular: true
    }
  },
  methods: {
    getTime (prodClass) {
      this.$remote.post(BUYTIMESTATE + '?_locale=' + this.$exchangeLang(this.RnInfo.language), {}, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.buyTimeState === 'true') {
            this.$store.commit('prodClass', prodClass)
            this.$router.push({ name: 'IntelligentDepositProducts' })
          } else {
            console.log('false')
            Dialog.alert({
              content: this.$t('label.label3'),
              cancelText: this.$t('btn.btn2'),
              confirmText: this.$t('btn.btn1'),
              onConfirm: () => window.emitRNFunction('goToPage')
            })
          }
        })
    },
    clearStore () {
      this.$store.commit('headerInfo', '')
      this.$store.commit('buyProInfo', '')
      this.$store.commit('prodClass', '')
      this.$store.commit('proInfo', '')
      this.$store.commit('proInfoDetails', '')
    },
    getList () {
      this.$remote.post(LOGINPRODLIST + '?_locale=' + this.$exchangeLang(this.RnInfo.language), {}, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          res.list.forEach(item => {
            if (item.prodType === 'FP01060006' && !this.showRegular) {
            } else {
              this.textData.push(item)
            }
          })
          console.log(this.textData)
        })
    }
  },
  created () {
    this.getList()
    this.clearStore()
  }
}
</script>
<style lang="stylus" scoped>
  #ProductCategories{
    .GridB6639132{
      box-shadow 0 .08rem .08rem 0 #F0F4F9
      border-radius .12rem
      margin  0 .3rem
      .GridF3434C50{
        height 1.43rem
        background #FFFFFF
        display flex
        position relative
        .Grid1C098D05{
          display flex
          font-size .3rem
          color #2F83F5
          font-weight 500
          height 1.43rem
          line-height 42px
          flex 2
          justify-content center
          flex-direction column
          padding-left .27rem
        }
        .Grid9E420243{
          display flex
          flex 3
          flex-direction column
          width 100%
          justify-content center
          align-items flex-start
          background-size 100%
          .textUp{
            font-size 28px
            font-weight 400
            color #1E1E1E
            line-height .4rem
          }
          .textDown{
            height .33rem
            font-size .24rem
            font-weight 400
            color #666666
            line-height .33rem
          }
        }
      }
      .GridF3434C50:before{
        content ''
        width .04rem
        height .34rem
        position absolute
        background #2F83F5
        top 50%
        transform translateY(-50%)
      }
      .GridF3434C50:after{
        content ''
        width 95%
        height .02rem
        position absolute
        background #ECECEC
        left 50%
        bottom 0
        transform translateX(-50%)
      }
      div:last-child:after{
        content none
      }
    }
  }

</style>
